import React from "react";
import "./read-time.m.css";

export default function ReadTime({ time }) {
  return <span styleName="read-time">{time} MIN READ</span>;
}
